import React, { useState, useEffect } from 'react'
import prod from '../assets/prod.jpg'
import { MdArrowForwardIos } from "react-icons/md";
import { FaArrowRight } from "react-icons/fa6";
import prod1 from "../assets/prod1.jpg"
import prod2 from "../assets/prod2.png"
// import prod3 from "../assets/prod3.png"
// import prod4 from "../assets/prod4.png"
// import prod5 from "../assets/prod5.png"
import prod6 from "../assets/prod6.png"
import prod7 from "../assets/prod7.png"
import prod8 from "../assets/prod8.png"
import prod9 from "../assets/prod9.png"
import prod10 from "../assets/prod10.png"
import prod11 from "../assets/prod11.png"
import perf from "../assets/perf.jpg"
import Footer from './Footer';
// import { GrDocumentPdf } from "react-icons/gr";
import { Link } from 'react-router-dom';
import Navigation from './Navigation';

const ProductsPage = () => {
    const [isVisible, setIsVisible] = useState(false);

    useEffect(() => {
        // Trigger animations after component mounts
        setIsVisible(true);
        
        // // Scroll to top when component mounts
        // window.scrollTo(0, 0);
    }, []);

    return (
        <>
            <div className='sticky top-0 z-50 w-full bg-white shadow-md'>
                <Navigation/>
            </div>
            
            {/* Hero Section with Fade-in Animation */}
            <div className="relative overflow-hidden">
                <img 
                    src={prod} 
                    alt="Product" 
                    className="w-full h-[210px] object-cover transform transition-transform duration-1000 hover:scale-105"
                />
                <div className="absolute inset-0 flex items-center justify-start px-4 xl:px-20 bg-black/40">
                    <h1 className={`uppercase text-xl md:text-2xl lg:text-5xl text-white transform transition-all duration-700 ${isVisible ? 'translate-x-0 opacity-100' : '-translate-x-10 opacity-0'}`}>
                        Products
                    </h1>
                </div>
            </div>

            {/* Breadcrumb with Slide-in Animation */}
            <div className="w-full px-4 xl:px-20 py-3 xl:py-5 overflow-hidden">
                <div className={`flex flex-wrap items-center gap-2 text-md md:text-lg transform transition-all duration-700 ${isVisible ? 'translate-y-0 opacity-100' : 'translate-y-5 opacity-0'}`}>
                    <Link to="/" className="uppercase text-green-700 hover:underline transition-colors duration-300">
                        Home
                    </Link>
                    <MdArrowForwardIos className="text-gray-600 text-xs mt-0.5" />
                    <p className="uppercase text-md md:text-lg text-gray-800">
                        Products
                    </p>
                </div>
            </div>

            {/* Featured Products Section with Staggered Animation */}
            <div className="flex flex-col lg:flex-row items-center justify-center gap-6 px-4 lg:px-20 py-6 lg:py-10">
                <Link to="/n3060" className={`transform transition-all duration-700 delay-100 ${isVisible ? 'translate-y-0 opacity-100' : 'translate-y-10 opacity-0'}`}>
                    <div className="relative group w-full overflow-hidden rounded-lg shadow-lg hover:shadow-xl transition-shadow duration-300">
                        <img 
                            src={prod1} 
                            alt="Product" 
                            className="w-full md:w-screen lg:w-full h-full object-contain transform transition-transform duration-500 group-hover:scale-105" 
                        />
                        <div className="absolute inset-0 bg-gradient-to-t from-black/70 to-transparent opacity-80 group-hover:opacity-90 transition-opacity duration-300" />
                        <div className="absolute top-4 left-2 xl:left-4 p-3 lg:p-4 xl:p-4 max-w-[70%] z-10">
                            <h1 className="text-2xl md:text-4xl text-white font-semibold">N3060</h1>
                            <p className="text-base md:text-3xl text-white lg:mt-2">
                                Fire Alarm Systems Integlex Multicrest Series
                            </p>
                        </div>
                        <div className="absolute bottom-4 right-4 opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                            <div className="bg-green-600 text-white px-4 py-2 rounded-full flex items-center">
                                <span className="mr-2">View Details</span>
                                <FaArrowRight />
                            </div>
                        </div>
                    </div>
                </Link>

                <Link to="/video" className={`hidden lg:flex flex-col items-center text-center relative group overflow-hidden rounded-lg shadow-lg hover:shadow-xl transform transition-all duration-700 delay-200 ${isVisible ? 'translate-y-0 opacity-100' : 'translate-y-10 opacity-0'}`}>
                    <img 
                        src={perf} 
                        alt="Product Video" 
                        className="w-full h-auto object-contain transform transition-transform duration-500 group-hover:scale-105" 
                    />
                    <div className="absolute inset-0 bg-black bg-opacity-60 group-hover:bg-opacity-70 transition duration-300 z-0" />
                    <div className="absolute inset-0 flex flex-col items-center justify-center z-10 p-4">
                        <h1 className="text-2xl lg:text-4xl text-white mb-4">
                            Product Videos
                        </h1>
                        <button className="text-xl text-white inline-flex uppercase items-center px-6 py-2 bg-green-600 transition-all duration-300 hover:bg-green-700 transform group-hover:scale-105 rounded-lg">
                            View All <FaArrowRight className="ml-3 group-hover:translate-x-1 transition-transform" />
                        </button>
                    </div>
                </Link>

                <Link to="/video" className={`flex lg:hidden w-full items-center justify-between px-6 py-4 border-2 border-gray-300 bg-white shadow-sm rounded-lg transform transition-all duration-700 delay-200 ${isVisible ? 'translate-y-0 opacity-100' : 'translate-y-10 opacity-0'} hover:shadow-md hover:border-green-600 transition-all duration-300`}>
                    <h1 className="text-lg lg:text-xl text-black font-medium">Product Videos</h1>
                    <FaArrowRight className="w-5 h-5 text-green-700 group-hover:translate-x-1 transition-transform" />
                </Link>
            </div>

            {/* Product Categories with Fade-in Animation */}
            <div className="px-4 xl:px-20 py-4 xl:py-6">
                <div className={`flex flex-col items-start w-full transform transition-all duration-700 delay-300 ${isVisible ? 'translate-y-0 opacity-100' : 'translate-y-5 opacity-0'}`}>
                    <h1 className="text-2xl xl:text-4xl font-semibold text-gray-900">
                        Fire Alarm Systems
                    </h1>
                    <div className="border-t-4 border-green-700 mt-4 w-full max-w-6xl" />

                    {/* <div className="flex items-center justify-between bg-gray-100 border border-gray-200 shadow-sm px-4 py-3 w-full md:w-80 mt-7 rounded-lg group hover:bg-green-50 transition-colors duration-300">
                        <h1 className="text-base font-semibold text-black">
                            Overall Product Brochure
                        </h1>
                        <a href="/" target="_blank" rel="noopener noreferrer" className="text-red-600 hover:scale-110 transition-transform duration-300 flex-shrink-0">
                            <GrDocumentPdf className="w-7 h-7" />
                        </a>
                    </div> */}
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mt-12">
                    {[
                        { img: prod2, title: "Addressable Systems", link: "/address", delay: 400 },
                        // { img: prod3, title: "Conventional Systems", delay: 450 },
                        // { img: prod4, title: "Notification Appliances", delay: 500 },
                        // { img: prod5, title: "Manual Stations", delay: 550 },
                        { img: prod6, title: "IR3 Flame Detectors", link: "/flame", delay: 600 },
                        { img: prod7, title: "Aspirating Smoke Detector", link: "/smoke", delay: 650 }
                    ].map((item, index) => (
                        <div 
                            key={index} 
                            className={`border-t-4 border-green-600 shadow-sm overflow-hidden rounded-lg transform transition-all duration-700 hover:-translate-y-1 hover:shadow-lg ${isVisible ? 'translate-y-0 opacity-100' : 'translate-y-5 opacity-0'}`}
                            style={{ transitionDelay: `${item.delay}ms` }}
                        >
                            {item.link ? (
                                <Link to={item.link}>
                                    <ProductCard img={item.img} title={item.title} />
                                </Link>
                            ) : (
                                <ProductCard img={item.img} title={item.title} />
                            )}
                        </div>
                    ))}
                </div>
            </div>

            {/* Nitrogen Gas Systems Section */}
            <div className="px-4 xl:px-20 py-4 xl:py-6">
                <div className={`flex flex-col items-start w-full transform transition-all duration-700 delay-300 ${isVisible ? 'translate-y-0 opacity-100' : 'translate-y-5 opacity-0'}`}>
                    <h1 className="text-2xl xl:text-4xl font-semibold text-gray-900">
                        Nitrogen Gas Fire Suppression Systems
                    </h1>
                    <div className="border-t-4 border-green-700 mt-4 w-full max-w-6xl" />

                    {/* <div className="flex items-center justify-between bg-gray-100 border border-gray-200 shadow-sm px-4 py-3 w-full md:w-80 mt-7 rounded-lg group hover:bg-green-50 transition-colors duration-300">
                        <h1 className="text-base font-semibold text-black">
                            Overall Product Brochure
                        </h1>
                        <a href="/" target="_blank" rel="noopener noreferrer" className="text-red-600 hover:scale-110 transition-transform duration-300 flex-shrink-0">
                            <GrDocumentPdf className="w-7 h-7" />
                        </a>
                    </div> */}

                    {/* <div className="flex items-center justify-between bg-gray-100 border border-gray-200 shadow-sm px-4 py-3 w-full md:w-auto mt-4 rounded-lg group hover:bg-green-50 transition-colors duration-300">
                        <h1 className="text-base font-semibold text-black sm:whitespace-nowrap">
                            Affection of discharge sound on precision instruments
                        </h1>
                        <a href="/" target="_blank" rel="noopener noreferrer" className="text-red-600 hover:scale-110 transition-transform duration-300 flex-shrink-0 ml-4">
                            <GrDocumentPdf className="w-7 h-7 ml-3" />
                        </a>
                    </div> */}
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mt-12">
                    {[
                        { img: prod11, title: "Engineered Type", link: "/nn100", delay: 400 },
                        { img: prod8, title: "Package Type", link: "/nn100", delay: 450 }
                    ].map((item, index) => (
                        <div 
                            key={index} 
                            className={`border-t-4 border-green-600 shadow-sm overflow-hidden rounded-lg transform transition-all duration-700 hover:-translate-y-1 hover:shadow-lg ${isVisible ? 'translate-y-0 opacity-100' : 'translate-y-5 opacity-0'}`}
                            style={{ transitionDelay: `${item.delay}ms` }}
                        >
                            <Link to={item.link}>
                                <ProductCard img={item.img} title={item.title} />
                            </Link>
                        </div>
                    ))}
                </div>
            </div>

            {/* Foam Systems Section */}
            <div className="px-4 xl:px-20 py-4 xl:py-6">
                <div className={`flex flex-col items-start w-full transform transition-all duration-700 delay-300 ${isVisible ? 'translate-y-0 opacity-100' : 'translate-y-5 opacity-0'}`}>
                    <h1 className="text-2xl xl:text-4xl font-semibold text-gray-900">
                        Foam Extinguishing Systems
                    </h1>
                    <div className="border-t-4 border-green-700 mt-4 w-full max-w-6xl" />
                </div>
                
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mt-12 mb-10">
                    {[
                        { img: prod9, title: "High Expansion", link: "/foam", delay: 400 },
                        { img: prod10, title: "Package Type", link: "/foamm", delay: 450 }
                    ].map((item, index) => (
                        <div 
                            key={index} 
                            className={`border-t-4 border-green-600 shadow-sm overflow-hidden rounded-lg transform transition-all duration-700 hover:-translate-y-1 hover:shadow-lg ${isVisible ? 'translate-y-0 opacity-100' : 'translate-y-5 opacity-0'}`}
                            style={{ transitionDelay: `${item.delay}ms` }}
                        >
                            <Link to={item.link}>
                                <ProductCard img={item.img} title={item.title} />
                            </Link>
                        </div>
                    ))}
                </div>
            </div>

            <div><Footer /></div>
        </>
    )
}

// Reusable Product Card Component
const ProductCard = ({ img, title }) => {
    return (
        <div className="bg-white border border-gray-300 border-t-0 group cursor-pointer overflow-hidden">
            <div className="overflow-hidden">
                <img 
                    src={img} 
                    alt={title} 
                    className="w-full h-48 object-contain transform transition-transform duration-500 group-hover:scale-110" 
                />
            </div>
            <h1 className="text-lg font-semibold text-black text-center px-3 py-4 group-hover:text-green-700 transition-colors duration-300">
                {title}
            </h1>
        </div>
    )
}

export default ProductsPage;